import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BookmarkService {
  bookmarksEnabled = false;
  get bookmarksAvailable(): boolean {
    return false;
  }
}
